// frontend/src/components/UI/ProtectedRoute.jsx - Protected Route Component
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loader from "./Loader";

const ProtectedRoute = ({
  children,
  adminOnly = false,
  superAdminOnly = false,
  teamMemberOnly = false,
  requireFarmer = false,
  requireSupplier = false,
  requireCustomer = false,
}) => {
  const {
    user,
    loading,
    isAdmin,
    isSuperAdmin,
    isTeamMember,
    isStaff,
    isFarmer,
    isCustomer,
    isSupplier,
  } = useAuth();
  const location = useLocation();

  if (loading) return <Loader />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (superAdminOnly && !isSuperAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (teamMemberOnly && !isTeamMember() && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireFarmer && !isFarmer()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireSupplier && !isSupplier()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireCustomer && !isCustomer()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (user.isActive === false) {
    return (
      <Navigate to="/login" state={{ error: "Account deactivated" }} replace />
    );
  }

  return children;
};

export default ProtectedRoute;
